import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import {
  PricingCard,
  IPricingCard,
  Price,
  BulletedList,
  PricingTooltip,
} from "@/components/PricingCard";
import { PricingSubtitle } from "@/containers/PricingSlider/PricingSubtitle";
import { Heading } from "@/components/Heading";
import { useTheme } from "@/hooks/useTheme";

type IProBackupCard = Pick<IPricingCard, "cta"> & {
  price: number;
  amount: number;
};

export const ProBackupCard: React.FC<IProBackupCard> = ({
  cta,
  price,
  amount,
}) => {
  const { t } = useTranslation("section/pricingFigmaBackup");
  const { colors } = useTheme();

  return (
    <PricingCard
      cta={cta}
      hideSupportedFormats
      customStyle={{
        filter: "drop-shadow(20px 20px 80px rgba(16, 5, 48, 0.08))",
        boxShadow: "none",
        nested: {
          "> div": {
            marginBottom: 24,
          },
        },
      }}
    >
      <Heading
        as="h4"
        customStyle={{ marginBottom: 24, color: colors.CHARCOAL }}
      >
        {t("backup", {
          plan: t("plans.pro"),
        })}
      </Heading>
      <Price
        value={price}
        suffix="month"
        customStyle={{
          color: colors.GRAY,
          nested: {
            "> strong": {
              fontSize: 36,
              lineHeight: "46px",
              color: colors.DARK_GREY,
            },
            "> span:first-child": {
              fontWeight: 700,
              verticalAlign: "text-top",
            },
            "> span:last-child span": {
              display: "inline-block",
              marginRight: 2,
            },
          },
        }}
      />
      <PricingSubtitle>{t("includesFiles", { amount })}</PricingSubtitle>

      <BulletedList>
        {t("description.backupCycle", { hours: 12 })}
        {t("description.fileRetention", { days: 90 })}
        <Trans
          i18nKey="section/pricingFigmaBackup:description.backupRegion"
          components={[
            <PricingTooltip
              key="pricing-pro-backupRegion"
              text={t("tooltips.s3Regions")}
            />,
          ]}
        />
        {t("description.figFiles")}
        {t("description.support")}
      </BulletedList>
    </PricingCard>
  );
};
